import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import Vue from 'vue'
const state = {
  teacherClazzs: {test: '1'},//老师管理的所有班级列表
  classMajorTypes: [],      //大专业
  classMajors: [],            //小专业
  gradeYears: [],            //年份
  // 侧边栏数据
  classInfoList: ''
}

const actions = {
  setClassroomById({commit}, param){
    commit(types.SET_MY_ClASSROOM, param);
  },
  setClassMajorTypes({commit}){
    http.FindClassMajorTypes()
      .then(res => {
        commit(types.SET_CLASSMAJORTYPE, res.data);
      });
  },
  setClassMajors({commit}, classMajors){
    commit(types.SET_CLASSMAJOR, classMajors);
  },
  setGradeYear({commit}, gradeYears){
    commit(types.SET_GRADEYEAR, gradeYears);
  },
  setClassroom({commit}, classrooms){
    commit(types.SET_CLASSROOMS, classrooms);
  },
  // 查询班级信息(侧边栏信息)
  queryClassInfo({commit}) {
    http.GetMyGivingClasses().then(res => {
      if (res.msgCode == '1') {
        commit(types.QUERY_CLASS_INFO_SUCCESS, res.data);
      }
    });
  }
}

const getters = {
  getTeacherClazzs: state => state.teacherClazzs,
  getClassMajorTypes: state => state.classMajorTypes
}

const mutations = {
  [types.SET_MY_ClASSROOM](state, clazzs) {
    Vue.set(state, 'teacherClazzs', clazzs);
  },
  [types.SET_CLASSMAJORTYPE](state, classMajorTypes){
    Vue.set(state, 'classMajorTypes', classMajorTypes)
  },
  [types.SET_CLASSMAJOR](state, classMajors){
    Vue.set(state, 'classMajors', classMajors)
  },
  [types.SET_GRADEYEAR](state, gradeYears){
    Vue.set(state, 'gradeYears', gradeYears)
  },
  [types.SET_CLASSROOMS](state, classrooms){
    Vue.set(state, 'classrooms', classrooms)
  },
  [types.QUERY_CLASS_INFO_SUCCESS](state, data){
    Vue.set(state, 'classInfoList', data)
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/classroom.js